import { render, staticRenderFns } from "./ProjectOffer.vue?vue&type=template&id=d819d38c&"
import script from "./ProjectOffer.vue?vue&type=script&lang=js&"
export * from "./ProjectOffer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOffer.vue?vue&type=style&index=0&id=d819d38c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports